import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MapItem } from 'app/shared/models/Progression/progression';
import { ProgressionService } from 'app/shared/services/progression/progression.service';

interface DialogData {
  item: MapItem;
}

@Component({
  selector: 'app-opendialog-view-img',
  templateUrl: './opendialog-view-img.component.html',
  styleUrls: ['./opendialog-view-img.component.scss']
})
export class OpendialogViewImgComponent implements OnInit {
  imageBase64: string;

  constructor(
    public dialogRef: MatDialogRef<OpendialogViewImgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private progressionService: ProgressionService

  ) { }

  ngOnInit(): void {
    this.getImg();
  }

  private getImg(): void {


    this.progressionService.getProgressionImg(this.data.item.itemId).subscribe(res => {
      this.imageBase64 = res;
    });
  }

}
